import cn from 'classnames'
import * as React from 'react'
import Typography from '../typography/Typography'
import styles from './Badge.module.css'
import { BadgeProps } from './Badge.types'

function Badge({ children, className, variant = 'body-m-bold-flat' }: BadgeProps) {
  return (
    <Typography
      as="span"
      variant={variant}
      className={cn(styles.badge, className)}
    >
      {children}
    </Typography>
  )
}

Badge.displayName = 'Badge'

export default Badge
